import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, ShieldCheckIcon, CreditCardIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingCard() {
  return <section id="pricing" className="py-10 sm:py-14 px-4 relative scroll-mt-10" data-id="element-180">
      <div className="absolute inset-0 bg-brand-orange/10 blur-[150px] rounded-full max-w-3xl mx-auto" data-id="element-181" />

      <div className="max-w-md sm:max-w-lg mx-auto relative z-10" data-id="element-182">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-black text-center mb-6 text-brand-cream" data-id="element-183">
          L'Offerta Imperdibile
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-b from-[#1a0f0a] to-[#120a06] border border-brand-orange/40 rounded-3xl relative shadow-[0_0_50px_rgba(249,115,22,0.15)]" data-id="element-184">
          {/* IL PIÙ SCELTO Badge */}
          <div className="flex justify-center -mt-4 mb-2" data-id="element-185">
            <div className="bg-gradient-to-b from-brand-gold to-amber-500 text-black font-black px-5 py-1.5 rounded-full flex items-center gap-1.5 uppercase tracking-wide text-xs shadow-[0_0_20px_rgba(251,191,36,0.5)]" data-id="element-186">
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-187" />
              IL PIÙ SCELTO
            </div>
          </div>

          <div className="p-6 sm:p-8" data-id="element-188">
            <h3 className="text-lg sm:text-xl font-black text-center text-brand-cream uppercase mb-6 leading-tight" data-id="element-189">
              IL VALUE STACK COMPLETO:
            </h3>

            <div className="space-y-0 mb-5" data-id="element-190">
              {[{
              label: '6 Tomi Completi del Sistema (400+ pagine)',
              price: '€282'
            }, {
              label: 'Bonus 1 — Kit Inclusività Totale BES/DSA',
              price: '€47'
            }, {
              label: 'Bonus 2 — IA Generativa in Classe',
              price: '€67'
            }, {
              label: 'Bonus 3 — Educazione Civica e Debate',
              price: '€47'
            }, {
              label: 'Bonus 4 — Registro Veloce + Griglie',
              price: '€37'
            }].map((item, i) => <div key={i} className="flex justify-between items-center border-b border-white/10 py-3" data-id="element-191">
                  <span className="text-gray-300 font-medium text-sm sm:text-base" data-id="element-192">
                    {item.label}
                  </span>
                  <span className="text-gray-500 line-through text-sm sm:text-base" data-id="element-193">
                    {item.price}
                  </span>
                </div>)}
              <div className="flex justify-between items-center pt-4" data-id="element-194">
                <span className="text-base sm:text-lg font-black text-brand-cream uppercase" data-id="element-195">
                  VALORE TOTALE:
                </span>
                <span className="text-xl sm:text-2xl font-black text-brand-danger line-through" data-id="element-196">
                  €480
                </span>
              </div>
            </div>

            {/* Why only 19,90 explanation */}
            <div className="bg-brand-card/60 border border-brand-gold/30 rounded-2xl p-5 mb-5" data-id="element-197">
              <p className="text-brand-gold font-black text-sm uppercase tracking-wide mb-2 text-center" data-id="element-198">
                💡 Perché solo €19,90?
              </p>
              <p className="text-gray-300 text-sm font-medium leading-relaxed text-center" data-id="element-199">
                Abbiamo eliminato stampa, distribuzione e intermediari delle
                grandi case editrici. Non paghi carta o spedizione — paghi
                l'accesso immediato a un sistema digitale aggiornato ogni anno
                scolastico, creato da docenti per docenti.
              </p>
            </div>

            {/* Inner offer card */}
            <div className="bg-[#1f110a] border border-brand-orange/40 rounded-2xl p-5 text-center mb-5" data-id="element-200">
              <p className="text-brand-orange font-bold text-sm mb-2" data-id="element-201">
                Offerta di Lancio (Solo per oggi):
              </p>
              <div className="flex justify-center items-center gap-2 mb-1" data-id="element-202">
                <span className="text-2xl" data-id="element-203">🏆</span>
                <span className="text-3xl sm:text-4xl font-black text-brand-cream" data-id="element-204">
                  Solo €19,90
                </span>
              </div>
              <p className="text-xs text-gray-400 mt-1" data-id="element-205">
                (Pagamento unico, accesso a vita)
              </p>
            </div>

            {/* Salirà presto pill */}
            <div className="flex justify-center mb-5" data-id="element-206">
              <div className="inline-flex items-center gap-2 border border-brand-orange/40 bg-brand-orange/5 px-4 py-1.5 rounded-full" data-id="element-207">
                <ShieldCheckIcon className="w-4 h-4 text-brand-orange" data-id="element-208" />
                <span className="text-xs font-bold text-brand-orange" data-id="element-209">
                  Prezzo di lancio — salirà presto
                </span>
              </div>
            </div>

            <CTAButton href="https://italia.kitonline.shop/cart/44566018293895:1" className="w-full mb-5" data-id="element-210">
              SÌ, VOGLIO IL SISTEMA COMPLETO ORA
            </CTAButton>

            <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 text-[11px] sm:text-xs text-gray-400 font-medium" data-id="element-211">
              <span className="flex items-center gap-1" data-id="element-212">
                <ZapIcon className="w-3 h-3 text-brand-gold" data-id="element-213" /> Download
                Immediato
              </span>
              <span className="text-gray-600" data-id="element-214">•</span>
              <span className="flex items-center gap-1" data-id="element-215">
                <CreditCardIcon className="w-3 h-3 text-brand-gold" data-id="element-216" /> Pagamento
                Unico
              </span>
              <span className="text-gray-600" data-id="element-217">•</span>
              <span className="flex items-center gap-1" data-id="element-218">
                <ShieldCheckIcon className="w-3 h-3 text-brand-gold" data-id="element-219" /> Garanzia
                30 Giorni
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}